import React from 'react';

import './style.scss';

const Footer = () => (
  <div className="footer">
    <hr />
    <div className="footer__inner">
      <div className="footer__column">
        <span className="footer__caption">режим работы</span>
        <div className="footer__schedule">
          <span>пн-пт: с 8:30 до 17:00</span>
          <span>сб-вс: выходной</span>
        </div>
      </div>
      <div className="footer__column">
        <span className="footer__caption">телефоны</span>
        <span>8 4852 58 16 45</span>
        <span>8 910 971 55 59</span>
      </div>
      <div className="footer__column">
        <span className="footer__caption">e-mail</span>
        <span>order@yartf.ru</span>
        <br />
      </div>
    </div>
    <div className="footer__sign">© {new Date().getFullYear().toString().padEnd(5)}
      <a className="footer__sign__link" rel="noopener noreferrer" target="_blank" href="https://yartf.ru">Ярославская трикотажная фабрика</a>
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/ui/Footer/index.js